module.exports = __webpack_public_path__ + "img/4-3.dafa6f37.svg";